/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { Box } from '@mui/system';
import BackButton from '../../../../../components/shared/Buttons/BackButton';
import { useDispatch } from 'react-redux';
import Loader from '../../../../../components/ui-elements/loader';
import OrgAppsAuthProvidersList from '../views/organization/application/authProviders/OrgAppsAuthProvidersList';
import OrgAppAuthProviderCreationBtn from '../views/organization/application/authProviders/OrgAppAuthProviderCreationBtn';
import { useCallback } from 'react';
import { getAllOrgApplicationAuthProviders } from '../../../../../store/reducers/organization/orgAppAuthProvider/orgAppAuthProviderAction';

const ManageOrgApplicationAuthProvidersPage = () => {
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch()
    const fetchOrgAppAuths = useCallback(async () => {
        try {
            setLoading(true);
            await dispatch(getAllOrgApplicationAuthProviders()).unwrap()
            setLoading(false)
        } catch (error) {
            setLoading(false)

        }
    }, [dispatch])
    useEffect(() => {
        fetchOrgAppAuths()
    }, [fetchOrgAppAuths]);

    return (
        <>
            <Box m={6}>
                <Grid container spacing={4} >
                    <Grid item xs={12} sm={12} md={12}>
                        <BackButton pageTitle={'Manage Organizations Applications Identity Providers'} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} />

                    <Grid item xs={12} sm={6} md={6} >
                        <OrgAppAuthProviderCreationBtn />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                        {!loading ? <OrgAppsAuthProvidersList /> : (<Loader />)}
                    </Grid>

                </Grid>
            </Box>

        </>
    )

}

export default ManageOrgApplicationAuthProvidersPage; 